import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from '../api/api'; // Axios wrapper;

function ConfirmationModal({ target, confirmationName, confirmationTitle, onConfirmFinish,
                             confirmHandle, confirmationQuestion, param1=null, param2=null}) {

  return (
    <Modal
        show={target != null}
        onHide={() => onConfirmFinish(null)}
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title>
                Confirm {confirmationTitle}
            </Modal.Title>
        </Modal.Header>

        <Modal.Body>
            {target && (
                <>
                    {param2 !== null? confirmationQuestion(param1, param2) : confirmationQuestion(param1)} 

                    <div className="text-muted mt-2 fw-bold">
                        This action cannot be undone.
                    </div>
                </>
            )}
        </Modal.Body>

        <Modal.Footer>
            <Button
                variant="secondary"
                onClick={() => onConfirmFinish(null)}
            >
                Cancel
            </Button>

            <Button
                variant="danger"
                onClick={(e) => confirmHandle(e, target)}
            >
                {confirmationName}
            </Button>
        </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationModal;